import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { auth} from "./firebase";

function BlogForm() {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();

        const currentUser = auth.currentUser;

        if (!currentUser) {
            alert("You must be logged in to create a blog.");
            return;
        }

        try {
            const token = await currentUser.getIdToken();
            console.log(token)
            await axios.post(
                process.env.REACT_APP_API_URL+"/blogs",
                { title, content },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            alert("Blog created!");
            navigate("/");
        } catch (err) {
            console.error("Error posting blog:", err);
            alert("Error: " + (err.response?.data || err.message));
        }
    };



    return (
        <form onSubmit={submit}>
            <h2>Create Blog</h2>
            <input placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} />
            <textarea placeholder="Content" value={content} onChange={e => setContent(e.target.value)} />
            <button type="submit">Submit</button>
        </form>
    );
}

export default BlogForm;